import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import axiosInstance5000 from '../services/5000AxiosInstance';
import Snackbar from './Snackbar';

const ChangePassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState("");
    const [cPassword, setCPassword] = useState("");
    const [snackbarMessage, setSnackbarMessage] = useState('');


    const pageStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#000',
        color: '#fff',
        fontFamily: 'Arial, sans-serif',
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        background: '#111',
        padding: '20px',
        borderRadius: '10px 0px 0px 0px',
        boxShadow: '0 0 20px 10px rgba(143, 0, 255, 0.5)',
        width: '100%',
        maxWidth: '599px',
        height: '605px',
        textAlign: 'center',
        margin: '85px auto',
        boxSizing: 'border-box',
    };

    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    };

    const inputStyle = {
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: '1px solid #333',
        borderRadius: '5px',
        background: '#222',
        color: '#fff',
        boxSizing: 'border-box',
    };

    const buttonStyle = {
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: 'none',
        borderRadius: '5px',
        background: 'linear-gradient(90deg, rgba(58,29,132,1) 0%, rgba(123,36,203,1) 100%)',
        color: '#fff',
        cursor: 'pointer',
        boxSizing: 'border-box',
    };

    const linkStyle = {
        color: '#a2a2ff',
        textDecoration: 'none',
    };

    // const optionsStyle = {
    //     display: 'flex',
    //     justifyContent: 'space-between',
    //     alignItems: 'center',
    //     margin: '10px 0',
    // };

    const handleSaveChanges = async () => {
        if (password !== cPassword) {
            alert("Passwords do nto match");
        }
        else {
            try {
                const response = await axiosInstance5000.post('/changePassword', {
                    email,
                    password,
                });
                const { message } = response.data;
                setSnackbarMessage(`${message}`);
                setTimeout(() => {
                    setSnackbarMessage('');
                    navigate('/');
                }, 3000); // Hide snackbar after 3 seconds
            } catch (error) {
                setSnackbarMessage('Please try again.');
                setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
            }
        }
    };

    return (
        <div style={pageStyle}>
            <div style={containerStyle}>
                <h2>Change Password</h2>
                <form style={formStyle} onSubmit={(e) => { e.preventDefault(); handleSaveChanges(); }}>
                    <input
                        type="email"
                        required = {true}
                        placeholder="Email Id"
                        style={inputStyle}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        required={true}
                        placeholder="New Password"
                        style={inputStyle}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type="password"
                        required={true}
                        placeholder="Confirm Password"
                        style={inputStyle}
                        value={cPassword}
                        onChange={(e) => setCPassword(e.target.value)}
                    />
                    <button type="submit" style={buttonStyle}>Save Changes</button>
                </form>
                <p>Don't have an account? <a href="/signup" style={linkStyle}>Sign Up</a></p>
            </div>
            {snackbarMessage && <Snackbar message={snackbarMessage} />}
        </div>
    );
};

export default ChangePassword;
